// src/features/legalentity/lib.ts
// Pure helpers for the legal entity module — no React imports.

export function errMessage(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}

export function fmtDate(iso: string | undefined, locale: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
}

export const LEGAL_ENTITY_STATUS_KEYS: Record<string, string> = {
  LEGAL_ENTITY_STATUS_UNSPECIFIED: 'unspecified',
  LEGAL_ENTITY_STATUS_DRAFT: 'draft',
  LEGAL_ENTITY_STATUS_ACTIVE: 'active',
  LEGAL_ENTITY_STATUS_SUSPENDED: 'suspended',
  LEGAL_ENTITY_STATUS_LIQUIDATED: 'liquidated',
  LEGAL_ENTITY_STATUS_ARCHIVED: 'archived',
};

export const LEGAL_ENTITY_STATUS_VARIANT: Record<string, 'default' | 'success' | 'warning' | 'error'> = {
  LEGAL_ENTITY_STATUS_UNSPECIFIED: 'default',
  LEGAL_ENTITY_STATUS_DRAFT: 'default',
  LEGAL_ENTITY_STATUS_ACTIVE: 'success',
  LEGAL_ENTITY_STATUS_SUSPENDED: 'warning',
  LEGAL_ENTITY_STATUS_LIQUIDATED: 'error',
  LEGAL_ENTITY_STATUS_ARCHIVED: 'default',
};

export const LEGAL_ENTITY_FORM_KEYS: Record<string, string> = {
  LEGAL_ENTITY_FORM_UNSPECIFIED: 'unspecified',
  LEGAL_ENTITY_FORM_INDIVIDUAL: 'individual',
  LEGAL_ENTITY_FORM_SOLE_PROPRIETOR: 'soleProprietor',
  LEGAL_ENTITY_FORM_PARTNERSHIP: 'partnership',
  LEGAL_ENTITY_FORM_LIMITED_LIABILITY: 'limitedLiability',
  LEGAL_ENTITY_FORM_CORPORATION: 'corporation',
  LEGAL_ENTITY_FORM_PUBLIC_CORPORATION: 'publicCorporation',
  LEGAL_ENTITY_FORM_COOPERATIVE: 'cooperative',
  LEGAL_ENTITY_FORM_NONPROFIT: 'nonprofit',
  LEGAL_ENTITY_FORM_FOUNDATION: 'foundation',
  LEGAL_ENTITY_FORM_GOVERNMENT: 'government',
  LEGAL_ENTITY_FORM_BRANCH: 'branch',
  LEGAL_ENTITY_FORM_REPRESENTATIVE_OFFICE: 'representativeOffice',
  LEGAL_ENTITY_FORM_TRUST: 'trust',
  LEGAL_ENTITY_FORM_OTHER: 'other',
};

export const TAX_IDENTIFIER_KIND_KEYS: Record<string, string> = {
  TAX_IDENTIFIER_KIND_UNSPECIFIED: 'unspecified',
  TAX_IDENTIFIER_KIND_TAX_ID_PRIMARY: 'taxIdPrimary',
  TAX_IDENTIFIER_KIND_TAX_ID_SECONDARY: 'taxIdSecondary',
  TAX_IDENTIFIER_KIND_REGISTRATION_NUMBER: 'registrationNumber',
  TAX_IDENTIFIER_KIND_VAT_NUMBER: 'vatNumber',
  TAX_IDENTIFIER_KIND_STATISTICS_CODE: 'statisticsCode',
  TAX_IDENTIFIER_KIND_INDUSTRY_CODE: 'industryCode',
  TAX_IDENTIFIER_KIND_LICENSE_NUMBER: 'licenseNumber',
  TAX_IDENTIFIER_KIND_DUNS: 'duns',
  TAX_IDENTIFIER_KIND_LEI: 'lei',
  TAX_IDENTIFIER_KIND_OTHER: 'other',
};
